<template>
  <section>
    <div class="form-group m-form__group row">
      <div :class="[{'has-danger': errors.has('identification_number')}, 'col-lg-3']" >
        <label for="identification_number">{{ 'identification_number' | translate | capitalize }}</label>
        <input type="text" name="identification_number" v-model="identification_number" class="form-control form-control-danger m-input" v-validate="report_type === 7 || report_type === 14 ? 'required|numeric|min:4|max:12' : 'numeric|min:4|max:12' ">
        <span v-show="errors.has('identification_number')" class="m-form__help m--font-danger"> {{ errors.first('identification_number') }} </span>
      </div>
      <div :class="[{'has-danger': errors.has('start_date')}, 'col-lg-3']" >
        <label :for="'start_date'">{{'start_date' | translate | capitalize }}</label>
        <s-date-time-picker :id="'start_date'" :name="'start_date'" v-model="start_date" :options="config.start" :placeholder="'AAAA-MM-DD'" v-validate="report_type === 11  || report_type === 12 ? '' : 'required|validateDate'" @empty="start_date = $event"></s-date-time-picker>
        <span v-show="errors.has('start_date')" class="m-form__help m--font-danger"> {{errors.first('start_date')}} </span>
      </div>
      <div :class="[{'has-danger': errors.has('end_date')}, 'col-lg-3']" >
        <label :for="'end_date'">{{'end_date' | translate | capitalize }}</label>
        <s-date-time-picker :id="'end_date'" :name="'end_date'" v-model="end_date" :options="config.end" :placeholder="'AAAA-MM-DD'" v-validate="report_type === 11  || report_type === 12 ? '' : 'required|validateDate'" @empty="end_date = $event"></s-date-time-picker>
        <span v-show="errors.has('end_date')" class="m-form__help m--font-danger"> {{errors.first('end_date')}} </span>
      </div>
    </div>
    <div class="form-group m-form__group row">
      <div class="col-lg-12"  style="text-align: right;">
          <label for="">&nbsp;</label><br>
          <a href="#" class="btn btn-success m-btn m-btn--icon" @click.prevent="generateReport()">
            <span>
              <i class="la la-archive"></i>
              <span>{{ 'generate_report' | translate | capitalize }}</span>
            </span>
          </a>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import service from '@/services/superaccess'
export default {
  props: ['report_type'],
  data () {
    return {
      report_types: [],
      person_types: [
        { name: 'all', value: 0 },
        { name: 'responsible', value: 1 },
        { name: 'user', value: 2 }
      ],
      person_types_by: [
        { name: 'responsible', value: 1 },
        { name: 'user', value: 2 }
      ],
      show_blockade: false,
      movement_all: false,
      exception_type: '',
      exception_types: [],
      config: {
        start: {
          format: 'yyyy-mm-dd',
          minView: 2,
          autoclose: true,
          pickerPosition: 'bottom-left'
        },
        end: {
          format: 'yyyy-mm-dd',
          minView: 2,
          startDate: this.start_date,
          autoclose: true,
          pickerPosition: 'bottom-left'
        },
        date: {
          format: 'yyyy-mm-dd',
          minView: 2,
          startDate: this.date,
          autoclose: true,
          pickerPosition: 'bottom-left'
        }
      },
      start_date: moment().format('YYYY-MM-DD'),
      end_date: moment().format('YYYY-MM-DD'),
      date: moment().format('YYYY-MM-DD'),
      companies: [],
      company_ids: [],
      auth_types: [],
      auth_types_ids: [],
      all_departments: [],
      departments: [],
      control_points: [],
      levelProfile: [],
      identification_number: '',
      control_point: [],
      department: [],
      report_type: '',
      id_person: 0,
      person_type: '',
      validate: '',
      file_name: '',
      ocultSelCompany: true,
      is_property_admin: false,
      trainings: [],
      training: [],
      state: [],
      autho_state: [],
      autho_states: [{id: 1, title: 'Activos'}, {id: 0, title: 'Vencidos'}],
      states: [{id: 1, title: 'Diligenciadas'}, {id: 0, title: 'Pendientes'}],
      showDeparments: false,
      properties: [],
      property: [],
      payment_states: [{id: 'paid', title: 'Pagados'}, {id: 'not_paid', title: 'Pendientes'}],
      payment_state: [],
      level: '',
      is_condominium: false
    }
  },
  computed: {
    ...mapGetters({ shard: 'getUserShard', userData: 'getUserData' })
  },
  methods: {
    ...mapActions(['retrieveDataFormReport', 'getGenerateReport', 'checkCompany', 'isCondominium']),
    selectAllCompanies () {
      let companies = []
      if (this.company_ids.includes('all')) {
        if (this.company_ids.length > 1) {
          companies = []
        } else {
          this.companies.forEach(company => {
            companies.push(company.id)
          })
        }
        this.company_ids = companies
        window.$('#companies').selectpicker('val', this.company_ids)
      }
    },
    selectAllAuthTypes () {
      let auths = []
      if (this.auth_types_ids.includes('all')) {
        if (this.auth_types_ids.length > 1) {
          auths = []
        } else {
          this.auth_types.forEach(auth => {
            auths.push(auth.id)
          })
        }
        this.auth_types_ids = auths
        window.$('#auth_types').selectpicker('val', this.auth_types_ids)
      }
    },
    selectAllDepartments () {
      let depart = []
      if (this.department.includes('all')) {
        if (this.department.length > 1) {
          depart = []
        } else {
          this.departments.forEach(d => {
            depart.push(d.id)
          })
        }
        this.department = depart
        window.$('#departments').selectpicker('val', this.department)
      }
    },
    selectAllProperties () {
      let prop = []
      if (this.property.includes('all')) {
        if (this.property.length > 1) {
          prop = []
        } else {
          this.properties.forEach(p => {
            prop.push(p.shard)
          })
        }
        this.property = prop
        window.$('#properties').selectpicker('val', this.property)
      }
    },
    selectAllTrainings () {
      let train = []
      if (this.training.includes('all')) {
        if (this.training.length > 1) {
          train = []
        } else {
          this.trainings.forEach(t => {
            train.push(t.id)
          })
        }
        this.training = train
        window.$('#trainings').selectpicker('val', this.training)
      }
    },
    selectAllControlPoints () {
      let c_point = []
      if (this.control_point.includes('all')) {
        if (this.control_point.length > 1) {
          c_point = []
        } else {
          this.control_points.forEach(cp => {
            c_point.push(cp.id)
          })
        }
        this.control_point = c_point
        window.$('#control_points').selectpicker('val', this.control_point)
      }
    },
    selectAllAuthoStates () {
      let autho_s = []
      if (this.autho_state.includes('all')) {
        if (this.autho_state.length > 1) {
          autho_s = []
        } else {
          this.autho_states.forEach(as => {
            autho_s.push(as.id)
          })
        }
        this.autho_state = autho_s
        window.$('#autho_state').selectpicker('val', this.autho_state)
      }
    },
    validateDates () {
      if (this.start_date !== '' && this.end_date !== '') {
        if (Date.parse(this.end_date) < Date.parse(this.start_date)) {
          this.$toast('initial_date_higher_error', 4)
          return false
        } else {
          return true
        }
      } else {
        return true
      }
    },
    generateReport () {
      this.$validator.validateAll().then((res) => {
        if (res) {
          if (this.identification_number.length >= 4) {
            // this.$spinner.show()
            if (this.report_type === 7) {
              if (person_type.value === '1') {
                this.validate = 'validate-responsible'
              }
              if (person_type.value === '2') {
                this.validate = 'validate-user'
              }
            } else {
              this.validate = 'validate-person'
            }
            console.log(this.validate)
            service.post('/api/reports/' + this.validate, this.$store, { identification_number: this.identification_number })
              .then(res => {
                console.log(res.status)
                if (res.status === 200) {
                  this.id_person = res.data.person_id
                  this.downloadFile()
                } else {
                  swal({
                    type: 'warning',
                    html: this.$options.filters.capitalize('person_not_found'),
                    showConfirmButton: false,
                    timer: 5000
                  })
                  this.$spinner.remove()
                }
              })
              .catch(err => {
                console.log(err)
                this.$spinner.remove()
              })
          } else {
            this.$spinner.show()
            this.id_person = 0
            this.downloadFile()
          }
        }
      })
    },
    downloadFile () {
      this.file_name = this.$options.filters.translate(this.report_types[this.report_type - 1].name)
      this.getGenerateReport({ company_ids: this.company_ids.length > 0 ? this.company_ids : 0, auth_types_ids: this.auth_types_ids.length > 0 ? this.auth_types_ids : 0, show_blockade: this.report_type === 1 || this.report_type === 2 || this.report_type === 3 ? this.show_blockade : '', report_type: this.report_type, department: this.department.length > 0 ? this.department : 0, control_point: this.control_point.length > 0 ? this.control_point : 0, training: this.training, identification_number: this.identification_number !== '' ? this.identification_number : 0, date: this.date !== '' ? this.date : '0000-00-00', start_date: this.start_date !== '' ? this.start_date : '0000-00-00', end_date: this.end_date !== '' ? this.end_date : '0000-00-00', movement_all: this.movement_all, exception_type: this.exception_type !== '' ? this.exception_type : 0, id_person: this.id_person, person_type: this.person_type, state: this.state, autho_state: this.autho_state, payment_state: this.payment_state, property: this.property })
        .then((response) => {
          if (this.report_type !== 14) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            if (this.file_name === 'declaratoria covid-19') {
              link.setAttribute('download', `${this.$options.filters.capitalize(this.file_name)}_.xlsx`)
            } else {
              link.setAttribute('download', `${this.$options.filters.capitalize(this.file_name)}.xlsx`)
            }
            document.body.appendChild(link)
            link.click()
            this.$spinner.remove()
          } else {
            if (response.data.size <= 45) {
              swal({
                type: 'info',
                html: this.$options.filters.capitalize('no_information_statement'),
                showConfirmButton: false,
                timer: 5000
              })
              this.$spinner.remove()
            } else {
              const url = window.URL.createObjectURL(new Blob([response.data]))
              const link = document.createElement('a')
              link.href = url
              link.setAttribute('download', `${this.$options.filters.capitalize(this.file_name)}.pdf`)
              document.body.appendChild(link)
              link.click()
              this.$spinner.remove()
            }
          }
        })
        .catch(err => {
          console.log(err)
          this.$spinner.remove()
        })
    },
    checkIfCondominium () {
      this.isCondominium({ shard: this.shard.shard })
        .then((res) => {
          if (res.status === 200) {
            this.is_condominium = res.data.is_condominium
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
  },
  mounted () {
    window.scrollTo(0, 0)
    this.checkIfCondominium()
  },
  created () {
    this.$spinner.show()
    this.$validator.extend('validateDate', {
      getMessage: field => {
        return this.$options.filters.capitalize('initial_date_higher_error')
      },
      // Returns a boolean value
      validate: value => {
        return this.validateDates()
      }
    })
    this.report_types = [
      { name: 'present_personal', value: 1 },
      { name: 'authorized_personal', value: 2 },
      { name: 'staff_about_to_expire', value: 3 },
      { name: 'historical_access', value: 4 },
      { name: 'exceptions', value: 5 },
      { name: 'assists', value: 6 },
      { name: 'authorized_by_person', value: 7 },
      { name: 'use_of_the_system', value: 8 }
    ]
    this.checkCompany(this.shard.company_id)
      .then(res => {
        this.is_property_admin = res.data.value
        this.report_types.push({ name: 'public_vehicles', value: 9 }, { name: 'forced_access', value: 10 }, { name: 'training_covid19', value: 11 }, { name: 'declaration_covid19', value: 12 }, { name: 'temperature_covid19', value: 13 }, { name: 'individual_declaration_covid19', value: 14 }, { name: 'system_charges', value: 15 })
        if (this.is_condominium === 'true') {
          this.report_types.push({ name: 'minute', value: 16 })
        }
        // if (this.is_property_admin) {
        //   this.report_types.push({ name: 'public_vehicles', value: 9 }, { name: 'forced_access', value: 10 }, { name: 'training_covid19', value: 11 })
        // } else {
        //   this.report_types.push({ name: 'training_covid19', value: 11 })
        // }
      })
      .catch(err => {
        console.log(err)
      })
    this.checkIfCondominium()
    this.retrieveDataFormReport()
      .then(res => {
        this.level = res.data.levelProfile.level
        this.companies = res.data.companies
        this.all_departments = res.data.departments
        this.control_points = res.data.control_points
        this.trainingsByCompany = res.data.trainings
        this.levelProfile = res.data.levelProfile
        this.properties = res.data.properties
        this.auth_types = res.data.auth_types
        if (this.level >= 3) {
          this.ocultSelCompany = false
          this.company_ids = [this.$store.getters.getUserShard.company_id]
        } else {
          this.ocultSelCompany = true
          this.report_types.value <= 8
        }
        window.$('#companies').selectpicker('val', this.companies)
        window.$('#departments').selectpicker('val', this.departments)
        window.$('#control_points').selectpicker('val', this.control_points)
        window.$('#trainings').selectpicker('val', this.trainings)
        window.$('#properties').selectpicker('val', this.properties)
        window.$('#auth_types').selectpicker('val', this.auth_types)
        this.$spinner.remove()
      })
      .catch(err => {
        console.log(err)
        this.$spinner.remove()
      })
  },
  watch: {
    companies (newVal, oldVal) {
      this.$nextTick()
        .then(() => {
          window.$('.m_selectpicker').selectpicker('refresh')
        })
    },
    company_ids (newVal, oldVal) {
      this.departments = []
      this.trainings = []
      this.all_departments.forEach(department => {
        if (newVal.includes(department.company_id)) {
          if (department.name.includes('-default-visited')) {
            department.name = department.name.replace('default-visited', 'Visitantes')
          }
          this.departments.push(department)
        }
      })
      this.trainingsByCompany.forEach(training => {
        if (newVal.includes(training.company_id)) {
          this.trainings.push(training)
        }
      })
      this.$nextTick()
        .then(() => {
          window.$('#departments').selectpicker('val', this.departments)
          window.$('#trainings').selectpicker('val', this.trainings)
          // document.getElementById('departments').selectedIndex = '0'
          window.$('.m_selectpicker').selectpicker('refresh')
        })
    },
    report_type (newVal, oldVal) {
      this.$nextTick()
        .then(() => {
          if (newVal !== 5) window.$('.m_selectpicker').selectpicker('refresh')
          // window.$('.m_selectpicker').selectpicker('refresh')
          // window.$('#departments').selectpicker('val', this.departments)
          window.$('#control_points').selectpicker('val', this.control_points)
          window.$('#trainings').selectpicker('val', this.trainings)
          this.identification_number = ''
        })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// PublicVehiclesForm.vue